import React from "react";
import { StarIcon, QuoteIcon, BadgeCheckIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { testimonials } from "../../data/content";
export function Testimonials() {
  return <section className="bg-ink-900 px-5 py-16 sm:py-20" data-id="element-249" data-mp="3mepnd1ioybv5">
      <div className="mx-auto max-w-6xl" data-id="element-250" data-mp="3r8k9scpol4xx">
        <SectionHeading kicker="What other dentists are saying" title="Professional Resources Should Be Useful, Clear, and Easy to Navigate" data-id="element-251" data-mp="3r9bxz2gy80e6" />
        <div className="grid gap-5 md:grid-cols-2" data-id="element-252" data-mp="4188znvgjcrp">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-ink-800 p-6 ring-1 ring-white/10 sm:p-7" data-id="element-253" data-mp="937b6ufgo3n2">
              <div className="flex items-center gap-4" data-id="element-254" data-mp="e07h95cb96e6">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-brand" loading="lazy" data-id="element-255" data-mp="2au2b9ygpaozl" />
                <div data-id="element-256" data-mp="2fslz64euuaul">
                  <figcaption className="flex items-center gap-1.5 font-display text-base font-extrabold text-white" data-id="element-257" data-mp="2fu6qzm9sbfor">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-brand" aria-label="Verified purchaser" data-id="element-258" data-mp="1nsrk6kh2ls3s" />
                  </figcaption>
                  <p className="text-sm text-slate-400" data-id="element-259" data-mp="1iuzmf9tqvbro">{t.role}</p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-260" data-mp="1eu5v06h3feu1">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-261" data-mp="2bh1055rlrln0" data-mpi={i} />)}
                  </div>
                </div>
              </div>
              <blockquote className="relative mt-5 text-[15px] leading-relaxed text-slate-100 sm:text-base" data-id="element-262" data-mp="22kjs4bejc3vh">
                <QuoteIcon className="mb-2 h-6 w-6 text-brand" aria-hidden="true" data-id="element-263" data-mp="r3k07gw3nr1z" />
                {t.quote}
              </blockquote>
            </figure>)}
        </div>
        <div className="mt-12" data-id="element-264" data-mp="m6jputs7w252">
          <CtaButton label="I Want to Explore Occlusion Blueprint" data-id="element-265" data-mp="nl4ecfx4j55a" />
        </div>
      </div>
    </section>;
}